/** Device-held identity: your name and the groups you have joined.
 *
 * The shared IdentityStore from @starling-cloud/sturnia-workshop, keyed
 * for scapescene. The participant token is identity, not auth — it lets
 * the onboarding member list rename/remove entries safely and makes
 * switching between previously joined groups a one-tap action. */

import { IdentityStore } from "@starling-cloud/sturnia-workshop";
import type { Identity, Membership } from "@starling-cloud/sturnia-workshop";

export type { Identity, Membership };

export const KEY = "scapescene-widget.identity.v1";

export const identityStore = new IdentityStore({ key: KEY });

export function getIdentity(): Identity {
  return identityStore.get();
}

export function setName(name: string): void {
  identityStore.setName(name);
}

export function upsertMembership(membership: Membership): void {
  identityStore.upsertMembership(membership);
}

export function updateGroupName(code: string, groupName: string): void {
  identityStore.updateGroupName(code, groupName);
}

export function removeMembership(code: string): void {
  identityStore.removeMembership(code);
}

export function setActive(code: string | null): void {
  identityStore.setActive(code);
}

export function activeMembership(): Membership | null {
  return identityStore.activeMembership();
}
